import { API } from 'utils/api.config';

export async function getAllBBCUrduContentApi(page) {
  return await API.get(`api/bbc-urdu?page=${page}`);
}
